import React from 'react';
import { Link as RouterLink } from 'react-router';
import styles from './AppNavContent.module.scss';
import { SEARCH_PATH, TRACK_MY_TRANSLATIONS_PATH } from 'src/common/routes';
import { useTranslation } from 'src/i18n/shim/useTranslation';

const AppNavContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <nav aria-label={t('main-nav-aria')} className={styles.navLinks}>
      <RouterLink to={SEARCH_PATH} className={styles.navLink}>
        {t('main-nav-search-strings')}
      </RouterLink>
      <RouterLink to={TRACK_MY_TRANSLATIONS_PATH} className={styles.navLink}>
        {t('main-nav-track-translations')}
      </RouterLink>
    </nav>
  );
};

export default AppNavContent;
